module.exports = "/assets/aa0e9e791fed355b0e6bfc7d811cf037.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/small/flight.png
// module id = 227
// module chunks = 0